import { useContext } from 'react'
import { ProfileStoreContext } from './ProfileStoreProvider'

const useProfileStore = () => useContext(ProfileStoreContext)
export default useProfileStore
